import React from "react";
import SEO from "../components/SEO";
import Breadcrumb from "../components/Breadcrumb";
import FundingLabEnrollArea from "../components/FundingLabEnrollArea";
import FooterFour from "../components/FooterFour";
import NavBarThree from "../components/NavbarThree";

const FundingLabEnroll = () => {
  return (
    <>
      <SEO
        title="Enroll in Funding Lab"
        description="Reserve your seat in the next Funding Lab cohort."
        canonical="/fundinglab/enroll"
        noindex={true}
      />
      <NavBarThree />
      <Breadcrumb title={"Enroll in Funding Lab"} />
      <FundingLabEnrollArea />
      <FooterFour />
    </>
  );
};

export default FundingLabEnroll;
